import urljoin from 'url-join';
import { ClientContext } from '../core/ClientContextFactory';
import { PaymentMethodType } from '../enums/Tokens';

export const getPaymentMethodUrl = (
  context: ClientContext,
  paymentMethod: PaymentMethodType,
): string => {
  const moduleName = paymentMethod.toLowerCase().replace('_', '-');
  const remotePath = urljoin(
    context.session.modulesUrl,
    '/payment-methods/',
    moduleName,
  );

  return remotePath;
};

export const getPaymentMethodModule = (
  context: ClientContext,
  paymentMethod: PaymentMethodType,
) => {
  const url = getPaymentMethodUrl(context, paymentMethod);

  const PaymentMethodModule = context.moduleFactory.getModule({
    remotePath: url,
    path: 'PaymentMethod',
    scope: paymentMethod.toLowerCase().replace('_', ''),
  });

  return PaymentMethodModule;
};
